import { render, staticRenderFns } from "./editBrand.vue?vue&type=template&id=6994d892"
import script from "./editBrand.vue?vue&type=script&lang=js"
export * from "./editBrand.vue?vue&type=script&lang=js"
import style0 from "./editBrand.vue?vue&type=style&index=0&id=6994d892&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports